"use strict";
// NoLimit.ts
//
// Implementation for No Limit betting structure. Each player can put as much money
// as they want in the pot
Object.defineProperty(exports, "__esModule", { value: true });
exports.NoLimit = void 0;
const BettingStructure_1 = require("./BettingStructure");
/**
 *  No Limit betting configuration
 *
 *  Players are allowed to bet all the money they have in the bank
 */
class NoLimit extends BettingStructure_1.BettingStructure {
    validatePrefs(prefs) {
        if (!prefs.allowAllIn) {
            throw new Error("Players should be allowed to go all in.");
        }
        this.validatePositiveNumber(prefs.smallBlind, "smallBlind");
        this.validatePositiveNumber(prefs.bigBlind, "bigBlind");
    }
    constructor(prefs) {
        super(prefs);
        this.validatePrefs(prefs);
    }
    validateBet(bet, round) {
        this.validatePositiveNumber(bet.amount, "bet amount");
        if (bet.amount + bet.personalInPot < round.currentBet && !bet.isAllIn) {
            throw new Error("Not enough money to match the bet and the player is not all in.");
        }
    }
}
exports.NoLimit = NoLimit;
//# sourceMappingURL=NoLimit.js.map